/*!
 * Bootstrap-select v1.13.9 (https://developer.snapappointments.com/bootstrap-select)
 *
 * Copyright 2012-2019 SnapAppointments, LLC
 * Licensed under MIT (https://github.com/snapappointments/bootstrap-select/blob/master/LICENSE)
 */

(function (root, factory) {
    if (typeof define === "function" && define.amd) {
        // AMD. Register as an anonymous module unless amdModuleId is set
        define(["jquery"], function (a0) {
            return factory(a0);
        });
    } else if (typeof exports === "object") {
        // Node. Does not work with strict CommonJS, but
        // only CommonJS-like environments that support module.exports,
        // like Node.
        module.exports = factory(require("jquery"));
    } else {
        factory(jQuery);
    }
})(this, function (jQuery) {
    (function ($) {
        $.fn.selectpicker.defaults = {
            noneSelectedText: "No hay selección",
            noneResultsText: "No hay resultados {0}",
            countSelectedText: "Seleccionados {0} de {1}",
            maxOptionsText: [
                "Límite alcanzado ({n} {var} máximo)",
                "Límite del grupo alcanzado({n} {var} máximo)",
                ["elementos", "element"],
            ],
            multipleSeparator: ", ",
            selectAllText: "Seleccionar Todos",
            deselectAllText: "Desmarcar Todos",
            placeholder: "Selecciona una opción...",
        };
    })(jQuery);
});
